import { render, staticRenderFns } from "./dialogContact.vue?vue&type=template&id=4aaf3d4c&scoped=true"
import script from "./dialogContact.vue?vue&type=script&lang=js"
export * from "./dialogContact.vue?vue&type=script&lang=js"
import style0 from "./dialogContact.vue?vue&type=style&index=0&id=4aaf3d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf3d4c",
  null
  
)

export default component.exports